import { render, staticRenderFns } from "./PDFLoader520.vue?vue&type=template&id=38b5d289&scoped=true&"
import script from "./PDFLoader520.vue?vue&type=script&lang=ts&"
export * from "./PDFLoader520.vue?vue&type=script&lang=ts&"
import style0 from "./PDFLoader520.vue?vue&type=style&index=0&id=38b5d289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5d289",
  null
  
)

export default component.exports